import React from "react";
import Typography from "@mui/joy/Typography";
import Sheet from "@mui/joy/Sheet";
import LinkChip from "./LinkChip";
import SPTag from "../SPTag";
import OrgTag from "../OrgTag";

export default function ProjectModalDetails({ project }) {
  return (
    <Sheet
      sx={{
        flex: 1,
        borderRadius: "24px",
        overflowY: { xs: "visible", sm: "visible", md: "scroll" },
        paddingLeft: "16px",
        paddingRight: "16px",
        paddingBottom: "16px",
      }}
    >
      {project.orgs && project.orgs.length > 0 && (
        <>
          <Typography level="title-lg" sx={{ mt: 2, mb: 0.5 }}>
            {project.orgs.length > 1 ? "Organizations" : "Organization"}
          </Typography>
          <div
            style={{
              display: "flex",
              gap: "8px",
              flexWrap: "wrap",
            }}
          >
            {project.orgs.map((org, index) => (
              <OrgTag
                key={index}
                label={org.name}
                abvr={org.name}
                src={org.logo}
                color={org.color}
                size="medium"
              />
            ))}
          </div>
        </>
      )}
      {project.skills && project.skills.length > 0 && (
        <>
          <Typography level="title-lg" sx={{ mt: 2, mb: 0.5 }}>
            {project.skills.length > 1 ? "Skills" : "Skill"}
          </Typography>
          <div
            style={{
              display: "flex",
              gap: "8px",
              flexWrap: "wrap",
            }}
          >
            {project.skills.map((skill, index) => (
              <SPTag key={index} label={skill} color="#1746A0" size="medium" />
            ))}
          </div>
        </>
      )}
      {project.programmingLanguages &&
        project.programmingLanguages.length > 0 && (
          <>
            <Typography level="title-lg" sx={{ mt: 2, mb: 0.5 }}>
              {project.programmingLanguages.length > 1
                ? "Programming Languages"
                : "Programming Language"}
            </Typography>
            <div
              style={{
                display: "flex",
                gap: "8px",
                flexWrap: "wrap",
              }}
            >
              {project.programmingLanguages.map((lang, index) => (
                <SPTag key={index} label={lang} color="#219C74" size="medium" />
              ))}
            </div>
          </>
        )}
      {project.materials && project.materials.length > 0 && (
        <>
          <Typography level="title-lg" sx={{ mt: 2, mb: 0.5 }}>
            {project.materials.length > 1
              ? "Related Materials"
              : "Related Material"}
          </Typography>
          <div
            style={{
              display: "flex",
              gap: "8px",
              flexWrap: "wrap",
            }}
          >
            {project.materials.map((material, index) => (
              <LinkChip
                key={index}
                title={material.title}
                subtitle={material.subtitle}
                linkProp={material.linkProp}
                href={material.href}
                buttonIcon={material.icon}
              />
            ))}
          </div>
        </>
      )}
    </Sheet>
  );
}
